import React from 'react';
import { Box } from '@mui/material';
import { motion } from 'framer-motion';
import { food } from '../../theme';

interface FloatingShapesProps {
  variant?: 'login' | 'dashboard' | 'subtle' | 'food';
}

const FloatingShapes: React.FC<FloatingShapesProps> = ({ variant = 'login' }) => {
  const shapes = variant === 'login'
    ? [
        { size: 400, x: '5%', y: '10%', color: 'rgba(224, 42, 42, 0.15)', delay: 0, duration: 25 },
        { size: 300, x: '75%', y: '55%', color: 'rgba(255, 230, 225, 0.12)', delay: 2, duration: 30 },
        { size: 250, x: '65%', y: '5%', color: 'rgba(232, 242, 234, 0.1)', delay: 4, duration: 22 },
        { size: 350, x: '15%', y: '65%', color: 'rgba(224, 42, 42, 0.1)', delay: 1, duration: 28 },
        { size: 200, x: '45%', y: '35%', color: 'rgba(255, 230, 225, 0.08)', delay: 3, duration: 20 },
      ]
    : variant === 'dashboard' || variant === 'food'
    ? [
        { size: 300, x: '80%', y: '10%', color: 'rgba(224, 42, 42, 0.08)', delay: 0, duration: 30 },
        { size: 200, x: '10%', y: '70%', color: 'rgba(255, 230, 225, 0.06)', delay: 2, duration: 25 },
        { size: 250, x: '60%', y: '80%', color: 'rgba(232, 242, 234, 0.05)', delay: 1, duration: 28 },
      ]
    : [
        { size: 200, x: '80%', y: '20%', color: 'rgba(224, 42, 42, 0.05)', delay: 0, duration: 30 },
      ];

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        overflow: 'hidden',
        pointerEvents: 'none',
        zIndex: 0,
      }}
    >
      {shapes.map((shape, index) => (
        <motion.div
          key={index}
          style={{
            position: 'absolute',
            width: shape.size,
            height: shape.size,
            left: shape.x,
            top: shape.y,
            background: `radial-gradient(circle, ${shape.color} 0%, transparent 70%)`,
            borderRadius: '50%',
            filter: 'blur(60px)',
          }}
          animate={{
            x: [0, 40, -30, 20, 0],
            y: [0, -40, 30, -15, 0],
            scale: [1, 1.15, 0.9, 1.08, 1],
          }}
          transition={{
            duration: shape.duration,
            delay: shape.delay,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />
      ))}
    </Box>
  );
};

export default FloatingShapes;
